import { QueryClient } from "@tanstack/react-query";
import { onSessionExpired } from "@/data";

/**
 * One query client for the app.
 *
 * The fallback stays frozen for demo reads. Every adapter query factory
 * overrides staleTime: fixtures stay frozen; HTTP reads expire after 30 seconds.
 *
 * `retry: false` so a thrown error reaches the screen immediately. The
 * screenshot suite asserts the console is clean, and three silent retries
 * before a visible failure is how a broken read ships as a blank panel.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: Number.POSITIVE_INFINITY, retry: false },
  },
});

onSessionExpired(() => {
  void queryClient.cancelQueries();
  queryClient.clear();
});
